import preparationImg from '../../assets/images/model_preparation.png';
import queueImg from '../../assets/images/model_queue.png';
import readyImg from '../../assets/images/model_ready.png';
import featureImg from '../../assets/images/model_feature-select.png';
import trainingImg from '../../assets/images/model_training.png';
import {
	ModelStatusWrapper,
	StepWrapper,
	IconWrapper,
	SpinningBorder,
	IconContainer,
	StatusImage,
	ConnectingLine,
} from './ModelStatus.styles';

const ModelStatus = ({ modelType, status }) => {
	// model type 1: image (4 steps)
	// model type 2: audio/sound (4 steps)
	// model type 3: time series (5 steps)

	// 0 -> draft, 2 -> upload => preparation
	// 3 -> queue => queue
	// 6 -> training => training
	// 1 -> ready => ready
	// 4 -> upload failed => preparation
	// 5 -> train failed => training

	const steps =
		modelType === 3
			? ['preparation', 'feature-select', 'queue', 'training', 'ready']
			: ['preparation', 'queue', 'training', 'ready'];

	const stepImages = {
		preparation: preparationImg,
		'feature-select': featureImg,
		queue: queueImg,
		training: trainingImg,
		ready: readyImg,
	};

	const getCurrentStepName = () => {
		switch (status) {
			case 0:
			case 2:
			case 4:
				return 'preparation';
			case 3:
				return 'queue';
			case 5:
			case 6:
				return 'training';
			case 1:
				return 'ready';
			default:
				return '';
		}
	};

	const activeStepName = getCurrentStepName();
	const activeStepIndex = steps.indexOf(activeStepName);

	const isFailed = status === 4 || status === 5;
	const failedStepIndex = isFailed ? activeStepIndex : -1;

	const getStepDisplayStatus = (stepIndex) => {
		if (status === 1) return 'completed'; // all completed if model is ready
		if (stepIndex < activeStepIndex) return 'completed';
		if (stepIndex === activeStepIndex) return 'active';
		return 'pending';
	};

	return (
		<ModelStatusWrapper>
			{steps.map((step, index) => {
				const stepDisplayStatus = getStepDisplayStatus(index);
				const isGrayscale = stepDisplayStatus === 'pending' || (stepDisplayStatus === 'active' && status === 6);
				const isStepFailed = index === failedStepIndex;

				return (
					<StepWrapper key={step} isFirst={index === 0}>
						<IconWrapper>
							<SpinningBorder isActive={stepDisplayStatus === 'active'} status={status} />
							<IconContainer isGrayscale={isGrayscale} isFailed={isStepFailed}>
								<StatusImage src={stepImages[step]} alt={step} />
							</IconContainer>
						</IconWrapper>
						{index < steps.length - 1 && (
							<ConnectingLine isPending={getStepDisplayStatus(index + 1) === 'pending'} />
						)}
					</StepWrapper>
				);
			})}
		</ModelStatusWrapper>
	);
};

export default ModelStatus;
